import React from 'react'
import CliniqueBlock from 'components/ui/CliniqueBlock'
import { IClinique } from 'components/core/types'
import { css, StyleSheet } from 'aphrodite'
import constants from 'utils/constants'

interface CliniquesListProps {
  cliniques: IClinique[],
}

export default ({ cliniques }: CliniquesListProps) => (
  <div className={css(styles.list)}>
    {cliniques.map((clinique: IClinique) => (<CliniqueBlock key={clinique.id} clinique={clinique} />))}
  </div>
)
const styles = StyleSheet.create({
  list: {
    display: 'flex',
    flexDirection: 'column',
    height: constants.map.height,
    padding: '0 12px 0 0',
    overflowY: 'scroll',
    direction: 'rtl',
    scrollbarColor: 'red',
  },
  '::-webkit-scrollbar': {
    width: '12px',
  },
})
